module.exports = __webpack_public_path__ + "static/img/tubiao.60b1634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/tubiao.png
// module id = SUmc
// module chunks = 1